// extracted by mini-css-extract-plugin
export default {"wrapper":"TxT4T","dot":"_22qu7","tooltip-content":"_3x0_q","tooltipContent":"_3x0_q"};